//

"use client";
import { ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";

export default function Goup({ widget }) {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    function onScroll() {
      const scrolled = window?.scrollY || document?.documentElement?.scrollTop;
      const full = document?.documentElement?.scrollHeight;

      setShowScrollTop(scrolled > full / 2);
    }

    onScroll();
    window?.addEventListener("scroll", onScroll, { passive: true });
    window?.addEventListener("resize", onScroll);

    return () => {
      window?.removeEventListener("scroll", onScroll);
      window?.removeEventListener("resize", onScroll);
    };
  }, []);

  function handleScrollTop() {
    if (typeof window === "undefined") return;
    window?.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (

    <button
      onClick={handleScrollTop}
      aria-label="برگشت به بالا"
      className="flex items-center justify-center bg-jmt-white gap-1 p-2 rounded-md cursor-pointer" >
      <ChevronUp className="w-5 h-5 lg:w-[22px] lg:h-[22px] text-jmt-neutral-800" />
      <span className="text-xs lg:text-sm font-bold text-jmt-neutral-800"> بازگشت به بالا </span>
    </button>
  );
}
